// src/components/ClickableSentence.js
import React from 'react';
import WordLookup from './WordLookup';
import ChineseLookup from './ChineseLookup'; // Import ChineseLookup component
import processSentenceJisho from '../utils/processSentenceJisho'; // Import Japanese processor
import logger from '../utils/logger'; // Import logger
// Removed import for processSentenceChinese as segmentation is now backend

const ClickableSentence = ({ sentence, lookupKey, language }) => {
    // Get current language from props or localStorage
    const currentLanguage = language || localStorage.getItem('learningLanguage') || 'Spanish';

    // Handle pre-processed Japanese sentences (React elements from processSentenceJisho)
    if (currentLanguage === 'Japanese' && React.isValidElement(sentence) && sentence.type === 'span' && sentence.props.className === 'japanese-sentence') {
        return <p className="story-text story-sentence japanese-sentence-processed">{sentence}</p>;
    }

    // Handle pre-segmented Chinese arrays
    if (currentLanguage === 'Chinese' && Array.isArray(sentence)) {
        const originalSentenceForContext = sentence.join(''); // Reconstruct for context prop
        return (
            <p className="story-text story-sentence chinese-sentence-processed">
                {sentence.map((word, index) => (
                    <ChineseLookup
                        key={`${lookupKey}-chinese-${index}-${word}`}
                        word={word}
                        sentence={originalSentenceForContext} // Pass reconstructed sentence
                    >
                        {word}
                    </ChineseLookup>
                ))}
            </p>
        );
    }

    // Handle plain strings (for space-delimited languages or fallbacks)
    if (typeof sentence === 'string') {
        let sentenceStr = sentence;
        let processedSentence;

        if (currentLanguage === 'Japanese') {
            // Japanese strings still need frontend processing
            processedSentence = processSentenceJisho(sentenceStr);
        } else if (currentLanguage === 'Chinese') {
             // Fallback for Chinese if backend didn't provide array
             logger.warn('ClickableSentence: Received string for Chinese, expected array. Rendering as plain text.');
             processedSentence = sentenceStr;
        } else {
            // Default processing for space-delimited languages
            const words = sentenceStr.split(' ').filter(Boolean);
            processedSentence = (
                <>
                    {words.map((word, index) => (
                        <WordLookup
                            key={`${lookupKey}-other-${index}-${word}` || index} // More robust key
                            word={word}
                            lookupKey={lookupKey}
                            language={currentLanguage}
                            sentence={sentenceStr}
                        >
                            {word}
                        </WordLookup>
                    ))}
                </>
            );
        }

        logger.debug(`ClickableSentence - Rendering for language "${currentLanguage}":`, sentenceStr);
        return (
            <p className="story-text story-sentence">
                {processedSentence}
            </p>
        );
    }

    // Fallback for unexpected data types
    logger.warn('ClickableSentence: Received unexpected sentence data type:', sentence);
    return <div className="story-text">{String(sentence)}</div>; // Render as string
};

export default ClickableSentence;